import type { ReactElement } from 'react'
import type { IconComponentType, NamedIconComponentType } from '../icon'
import type { ShapeComponentType } from '../shape/types'

export interface IconBlobProps {
  className?: string
  type?: IconBlobTypeType
  size?: IconBlobSizeType
  icon: IconComponentType | NamedIconComponentType
  blob?: ShapeComponentType
}

export enum IconBlobType {
  neutral = 'neutral',
  promotion = 'promotion',
  positive = 'positive',
  critical = 'critical',
  marketing = 'marketing',
}

export enum IconBlobSize {
  xlarge = 'xl',
  large = 'l',
  medium = 'm',
  small = 's',
}
export type IconBlobTypeType = `${IconBlobType}`
export type IconBlobSizeType = `${IconBlobSize}`
export type IconBlobComponentType = ReactElement<IconBlobProps>
